export const COLOR_PICKER_HOVER_GROUP_CLASS_NAME = 'colorPickerHoverGroup';
